import React from "react";
import ReactDOM from "react-dom";

function renderAddToBagButtonFor(productContainer) {
  import("../components/AddToBag").then((loadedModule) => {
    const addToBagContainer = productContainer.querySelector(".js-items-carousel-add-to-bag");
    if (addToBagContainer === null) {
      return;
    }

    const addToBagUrl = productContainer.getAttribute("data-product-add-url");
    const configData = JSON.parse(productContainer.getAttribute("data-product-children"));
    let sizeAttribute = null;
    if (configData.children) {
      const sizes = configData.children
        .filter((child) => child.qty !== 0)
        .map(function (child) {
          return {
            label: child.size,
            value: child.sizeAttributeOptionId,
          };
        });

      sizeAttribute = {
        id: configData.children[0].sizeAttributeId,
        sizes,
      };
    }

    const AddToBag = loadedModule.default;
    ReactDOM.render(<AddToBag addToBagUrl={addToBagUrl} sizeAttribute={sizeAttribute} />, addToBagContainer);
  });
}

export function attach(carouselEl) {
  carouselEl.querySelectorAll(".js-items-carousel-product").forEach((product) => {
    renderAddToBagButtonFor(product);
  });
}
